import React from 'react';
import { Link } from 'react-router-dom';
import { useGallery } from '../context/GalleryContext';
import { Seo } from '../components/seo/Seo';

export const NotFoundPage = () => {
    const { defaultRoute } = useGallery();
    return (
        <section>
            <Seo title="Not found" noindex />
            <div className="mb-5 text-eyebrow uppercase tracking-nav text-tone-800">404</div>
            <h1 className="text-title text-ink">Page not found</h1>
            <p className="mt-3 text-meta text-tone-800">The page you’re looking for doesn’t exist.</p>
            <Link to={`/${defaultRoute}`} className="btn mt-6">
                Back to the gallery
            </Link>
        </section>
    );
};
